import {
  APP_ROLES,
  ORG_ROLES,
} from 'features/common/components/OrganizationAppAccess/resource';
import { IGetRoleItem } from 'features/members/services/identity/rolesModel';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import mapValues from 'lodash/mapValues';
import { ITenantSelectOption } from 'features/members/components/table/utils/memberDetailsModel';
import {
  isFgaPrimaryDam,
  TenantLabel,
} from 'features/common/utils/tenantLabels';

/** SitecoreAI DAM roles for this phase. Value is sent to the API; label is shown in the dropdown. */
const SITECORE_AI_DAM_ACCESS_ROLES: ITenantSelectOption[] = [
  { value: 'Viewer', label: 'Viewer' },
  { value: 'Contributor', label: 'Contributor' },
  { value: 'Editor', label: 'Editor' },
  { value: 'Advanced User', label: 'Advanced user' },
];

export const getSitecoreAiDamAccessLabel = (roleName: string) =>
  SITECORE_AI_DAM_ACCESS_ROLES.find((role) => role.value === roleName)?.label;

/**
 * Gets a list of roles and a product code and returns a list of access options.
 * The SitecoreAI DAM list is hardcoded only for FGA-primary DAM
 * (productCode DAM and DeploymentMode scai_dam).
 * @param roles
 * @param productCode
 * @param labels tenant labels, including DeploymentMode
 */
const getAccessOptions = (
  roles: IGetRoleItem[] | undefined,
  productCode: string,
  labels?: TenantLabel[] | null,
): ITenantSelectOption[] => {
  if (productCode === 'Marketplace') {
    return [
      {
        value: 'Has access',
        label: 'Has access',
      },
    ];
  }

  if (isFgaPrimaryDam(productCode, labels)) {
    return SITECORE_AI_DAM_ACCESS_ROLES;
  }

  if (!roles || roles.length === 0) return [];

  const sorter = (role: IGetRoleItem) =>
    role.name === APP_ROLES.USER || role.name === ORG_ROLES.ORG_USER;

  // Groups per scope and sorts the roles with user first and then the rest
  const orderedOptionList = mapValues(groupBy(roles, 'scope'), (r) =>
    orderBy(r, [sorter], ['desc']),
  );

  const rolesForProduct = orderedOptionList[productCode];
  if (!rolesForProduct) return [];

  return rolesForProduct.map((r) => ({
    value: r.name,
    label: r.name,
  }));
};

export default getAccessOptions;
